export default "__VITE_ASSET__3WDiUEyU__"